// extracted by mini-css-extract-plugin
export default {"container":"FollowUs_container__27mo3","title":"FollowUs_title__QPKwR","list":"FollowUs_list__Wz7Yx"};